import React from 'react';
import { motion } from 'framer-motion';
import { Reveal, RevealLines } from './Reveal';
import { COCKTAILS } from '../data/site';

export default function Cocktails() {
  return (
    <section id="cocktails" className="relative py-32 md:py-48 px-6 md:px-10 max-w-[1600px] mx-auto" data-testid="cocktails-section">
      <div className="grid grid-cols-12 gap-6 md:gap-10 mb-20">
        <Reveal className="col-span-12 md:col-span-3">
          <div className="flex md:flex-col items-baseline md:items-start gap-4">
            <span className="font-mono text-gold text-sm tracking-[0.3em]">04 —</span>
            <span className="overline">La carte</span>
          </div>
        </Reveal>
        <div className="col-span-12 md:col-span-9">
          <h2 className="font-serif leading-[0.95] tracking-tight" style={{ fontSize: 'clamp(2.5rem, 6vw, 6rem)' }}>
            <RevealLines lines={['Les cocktails,', <span key="i" className="italic text-char/50">à la minute.</span>]} />
          </h2>
          <p className="mt-6 text-char/60 max-w-2xl">
            Une sélection de classiques irréprochables et de créations d'auteur — nous composons volontiers votre cocktail signature.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
        {COCKTAILS.map((c, i) => (
          <motion.article
            key={c.name}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-10% 0px' }}
            transition={{ duration: 0.8, delay: (i % 4) * 0.08, ease: [0.7, 0, 0.2, 1] }}
            className="group relative"
            data-testid={`cocktail-${c.name.toLowerCase().replace(/\s+/g, '-')}`}
          >
            <div className="relative aspect-[3/4] overflow-hidden bg-char/5">
              <img
                src={c.img}
                alt={`Cocktail ${c.name}`}
                loading="lazy"
                onError={(e) => { e.currentTarget.src = 'https://images.pexels.com/photos/613037/pexels-photo-613037.jpeg?auto=compress&cs=tinysrgb&w=1200'; }}
                className="w-full h-full object-cover grayscale-[15%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-[1200ms]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/10 to-transparent" />
              <div className="absolute top-3 left-3 font-mono text-gold text-[10px] tracking-[0.3em]">
                N° {String(i + 1).padStart(2, '0')}
              </div>
              {/* Spotlight ring */}
              <div className="absolute inset-0 ring-1 ring-inset ring-white/10 group-hover:ring-gold/40 transition-colors duration-700" />
            </div>
            <div className="pt-4 flex items-start justify-between gap-2">
              <div>
                <div className="font-serif text-xl md:text-2xl leading-tight">{c.name}</div>
                <div className="text-char/60 text-xs md:text-sm mt-1">{c.tagline}</div>
              </div>
              <span className="font-mono text-gold text-xs mt-1">·</span>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
